module.exports = __webpack_public_path__ + "static/monei_pay_3_en-8c357667546751ec62d91a8012a81ca1.png";